import React from "react";
import { QuiTooltip } from "../QuiTooltip/QuiTooltip.js";
export function WithTooltip(props) {
    if (!props.tooltip)
        return props.children;
    return (React.createElement(QuiTooltip, Object.assign({ content: props.tooltip }, props.tooltipProps), props.children));
}
